import DC from "../../common/DataConnector";
import { actCartTransportUpdate, actCartAddressUpdate } from "../Actions";

export async function changeAddressAndLoadTransportPrice(dispatch: any, address:any, onEnd:()=>void) {
    actCartAddressUpdate(dispatch,address.addressId)

    const trans = await DC.Get(`/customer/common/transport-price/${address.province.code}/${address.city.code}`);
    if (trans.wasOk) {
        if(trans.data.conf !== '')
            trans.data.conf = JSON.parse(trans.data.conf);
        else
            trans.data.conf = {}
        actCartTransportUpdate(dispatch, trans.data)
        onEnd()
    }
}